import {Link} from "gatsby"
import PropTypes from "prop-types"
import React, {Fragment} from "react"
import Select from 'react-select';
import LocationSelect from './locationSelect.js'

class OpenPositionForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }
  handleFileUpload = event => {
    if(event.target.files.length > 0)
      {
        document.getElementById('resume-file-name').innerHTML = event.target.files[0].name;
      }
  }
  render() {
    return (
      <Fragment>

        <form method="post" netlify-honeypot="bot-field" data-netlify="true" name="Open Positions">
          <input type="hidden" name="form-name" value="Open Positions" />
          <input type="hidden" name="bot-field"/>
          <input type="hidden" name="page" value={this.props.position}/>
          <div className="field">
            <label className="label">Email</label>
            <input required className="input" type="email" placeholder="Your email address" name="email"/>
          </div>
          <div className="field">
            <label className="label">Full Name</label>
            <input required className="input" type="text" placeholder="First & Last Name" name="name"/>
          </div>
          <div className="field">
            <label className="label">Your LinkedIn Page</label>
            <input required className="input" type="text" placeholder="https://www.linkedin.com/in/linkedinpage" name="linkedIn"/>
          </div>
          <div className="field">
            <label className="label">Cities of Interest (Select all that apply)</label>
            <LocationSelect/>
          </div>
          <div className="field">
            <label className="label">
              What is a headhunter AKA agency recruiter?</label>
            <textarea required className="textarea" type="text" placeholder="Write your answer here" name="question1"/>
          </div>
          <div className="field">
            <label className="label">
              How is headhunting different than Human Resources, Corporate, or Internal Recruiting?</label>
            <textarea required className="textarea" type="text" placeholder="Write your answer here" name="question2"/>
          </div>
          <div className="field">
            <label className="label">
              Why do you want to become a headhunter?</label>
            <textarea required className="textarea" type="text" placeholder="Write your answer here" name="question3"/>
          </div>
          <div className="field">
            <label className="label">
              Why would you be good at headhunting?</label>
            <textarea required className="textarea" type="text" placeholder="Write your answer here" name="question4"/>
          </div>
          <div className="field">
            <label className="label">
              Are you interested to learn more about remote positions?</label>
            <div className="control">
              <label className="radio">
                <input type="radio" name="interested-in-remote-positions"/>
                Yes
              </label>
              <label className="radio">
                <input type="radio" name="interested-in-remote-positions"/>
                No
              </label>
            </div>
          </div>
          <div className="field">
            <label className="label">
               Base salaries are $30k-40k for entry-level recruiters (NYC is the only exception of up to $50k for new recruiters). Working hours are Monday – Friday, 8am – 6:30pm in the office. Do you agree with this setup?</label>
            <div className="control">
              <label className="radio">
                <input type="radio" name="base-salary-agreement"/>
                Yes
              </label>
              <label className="radio">
                <input type="radio" name="base-salary-agreement"/>
                No
              </label>
            </div>
            <textarea required className="textarea" type="text" placeholder="Write your answer here" name="base-salary-note"/>

          </div>
          <div className="field">
          <label className="label">
             PLEASE ATTACH WORD DOC VERSION OF YOUR RESUME.</label>
          <div className="file has-name is-fullwidth">

            <label className="file-label">
              <input className="file-input" type="file" name="resume" onChange={this.handleFileUpload}/>
              <span className="file-cta">
                <span className="file-icon">
                  <i className="fas fa-paperclip"></i>
                </span>
                <span className="file-label">
                  Choose a file…
                </span>
              </span>
              <span id="resume-file-name" className="file-name">

              </span>
            </label>
          </div>
          </div>

          <div className="field">
            <input type="submit" className="button is-primary is-medium is-fullwidth" value="Submit"/>
          </div>
        </form>
        <div className="your-privacy-is-impo-wrapper">
          <br/>
          <p className="your-privacy-is-impo">
            Your privacy is important to us. Your message is 100% confidential and will only<br/>
            be submitted to the DG Recruit team privately. Thank you for your discretion.
          </p>
        </div>
      </Fragment>
    )
  }
}

export default OpenPositionForm
